import { render } from "./ChoseChaptesCircels.vue?vue&type=template&id=628f06c0&scoped=true"
import script from "./ChoseChaptesCircels.vue?vue&type=script&lang=js"
export * from "./ChoseChaptesCircels.vue?vue&type=script&lang=js"

import "./ChoseChaptesCircels.vue?vue&type=style&index=0&id=628f06c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628f06c0"]])

export default __exports__